import axios from "axios";
import * as actionType from "../actionTypes";
import apiConstants from "../../constans/apiConstants";
import { toaster } from "../../utils/utils";

export const getApiStatus = () => async (dispatch,cb) => {
    dispatch({ type: actionType.LOADER_TRUE });
    try {
        const { data } = await axios.get(
        `${apiConstants().PROPOSEL_API_URL}api/v1/apiConfig/getApiStatus
            `,
        {
            headers: {
            authorization: localStorage.getItem("token"),
            },
        }
        );
        dispatch({
            type: actionType.SWITCH_API_DATA,
            payload: data.body
        })
        dispatch({ type: actionType.LOADER_FALSE })
    } catch (err) {
        dispatch({ type: actionType.LOADER_FALSE })
        console.log(`err`, err);
    }
};


export const updateApiStatus = (data) => async (dispatch) => {
    try {   
        const res = await axios.put(`${apiConstants().PROPOSEL_API_URL}api/v1/apiConfig/updateApiStatus
        `, data, {
            headers: {
                authorization: localStorage.getItem("token"),
                },
        })
        dispatch(getApiStatus())
    } catch (err) {
        console.log(`err`, err)
    }
}
